import axios from './settingInstance'

export type SettingEntry = {
  key: string
  value: unknown
}

const isSettingEntry = (value: unknown): value is SettingEntry => {
  if (!value || typeof value !== 'object') return false

  const setting = value as Record<string, unknown>
  return typeof setting.key === 'string' && 'value' in setting
}

export default async (): Promise<SettingEntry[]> => {
  const response = await axios.get<unknown>('/settings')
  const data = response.data

  if (Array.isArray(data)) {
    return data.filter(isSettingEntry)
  }

  if (
    data &&
    typeof data === 'object' &&
    'settings' in data &&
    Array.isArray((data as { settings: unknown }).settings)
  ) {
    return (data as { settings: unknown[] }).settings.filter(isSettingEntry)
  }

  return []
}
